var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinutLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0763 41.1249L44.8563 1.68486C44.2163 0.264861 42.5463 -0.385139 41.1163 0.234861L1.68634 17.4549C0.256341 18.0949 -0.38366 19.7649 0.23634 21.1949L17.4463 60.6249C18.0863 62.0449 19.7563 62.6949 21.1863 62.0749L60.6263 44.8649C62.0463 44.2249 62.6963 42.5649 62.0863 41.1249H62.0763Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2471 17.9736C46.2471 19.3636 45.1471 20.5036 43.7571 20.5436H31.4671C26.8671 20.5436 23.1471 24.2736 23.1471 28.8636V31.6436C23.1471 36.2336 26.8571 39.9536 31.4471 39.9636H43.7371C45.1271 39.9836 46.2371 41.1236 46.2271 42.5136V44.7836C46.2271 46.1736 45.1271 47.3136 43.7371 47.3536H30.1971C22.3871 47.3536 16.0471 41.0136 16.0371 33.1936V27.4136C16.0371 27.4136 16.0371 27.3836 16.0371 27.3636C16.0371 19.5436 22.3671 13.1936 30.1971 13.1836H43.7671C45.1571 13.2336 46.2571 14.3636 46.2571 15.7536V17.9736H46.2471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinutLogo);
export default __webpack_public_path__ + "static/media/coinutLogo.9c95c24871c163964584bd90016d14b9.svg";
export { ForwardRef as ReactComponent };